import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    helpLink: 'Contact us',
    helpPrompt: "Have a question about your application's progress?",
    initialSubmission: {
      guideNextSteps: 'Discover the next steps',
      title: 'Your application has been submitted!',
    },
    subtitle:
      "We'll keep you informed of the progress of your application by email at **{email}**.",
    title: 'Follow up your application',
  },
  fr: {
    helpLink: 'Contactez-nous',
    helpPrompt: 'Une question sur votre suivi ?',
    initialSubmission: {
      guideNextSteps: 'Découvrez les prochaines étapes',
      title: 'Votre dossier est envoyé !',
    },
    subtitle:
      'Nous vous tenons informé·e de l’avancée de votre dossier par e-mail à **{email}**',
    title: 'Suivez l’avancement de votre dossier',
  },
} as const);

export default locales;
